import React from 'react';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Box, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';

interface OwnProps {
    noOfStops?: number;
    noOfPointInterest?: number;
    cms: CmsValue;
}

const RouteItemSubHeader: React.FC<OwnProps> = React.memo((props) => {
    const { noOfStops, noOfPointInterest, cms } = props;
    if (!noOfStops && !noOfPointInterest) {
        return null;
    }
    const noOfStopsText = noOfStops && noOfStops > 1 ? StringFormatter.format(cms[134235], noOfStops.toString()) : cms[134236];
    const noOfPointInterestText = noOfPointInterest && noOfPointInterest > 1 ? StringFormatter.format(cms[130965], noOfPointInterest.toString()) : cms[130966];
    return (
        <Box mx="16" data-testid="route-sub-header">
            {!!noOfStops && (
                <Typography mx="4" variant="body-s" tag="span">
                    {noOfStopsText}
                </Typography>
            )}
            {!!noOfStops && !!noOfPointInterest && <br />}
            {!!noOfPointInterest && (
                <Typography mx="4" variant="body-s" tag="span">
                    {noOfPointInterestText}
                </Typography>
            )}
        </Box>
    );
});
RouteItemSubHeader.displayName = 'RouteItemSubHeader';

export default RouteItemSubHeader;
